'use client';
import { useTranslations } from 'next-intl';

export const useLang = (key?: string) => {
    const t: any = useTranslations(key);

    return {
        t,
    };
};
